import { Star } from "lucide-react";
import { Reveal, SectionLabel } from "./shared";
import { useLang } from "./i18n";

export function Testimonials() {
  const { t } = useLang();
  return (
    <section id="stories" className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <SectionLabel>{t.testimonials.label}</SectionLabel>
          <h2 className="font-display text-4xl font-semibold leading-[1.1] tracking-[-0.02em] text-ink md:text-5xl">
            {t.testimonials.titleA} <span className="italic text-aqua-700">{t.testimonials.titleB}</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {t.testimonials.items.map((r, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="flex h-full flex-col rounded-3xl border border-slate-200 bg-paper p-8 transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_56px_rgba(15,27,45,0.08)]"
              >
                <div className="flex gap-1">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} size={15} className="fill-maple text-maple" />
                  ))}
                </div>
                <blockquote className="mt-5 flex-1 font-display text-lg italic leading-relaxed text-ink">
                  &ldquo;{r.text}&rdquo;
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3.5 border-t border-slate-200 pt-6">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy font-display text-sm font-semibold text-aqua-300">
                    {r.initials}
                  </span>
                  <div>
                    <div className="text-sm font-bold text-ink">{r.name}</div>
                    <div className="text-xs text-slate-400">{r.role}</div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
